import React from "react";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import { Field } from "redux-form";
import emailValidator from "email-validator";
import BasicField from "../components/BasicField";
import BasicCheckbox from "../components/BasicCheckBox";
import BasicNonEditField2 from "../components/BasicNonEditField2";

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export const validate = values => {
  const errors = {};

  if (!values.name) {
    errors.name = "required";
  }

  if (!values.email) {
    errors.email = "required";
  // } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}$/i.test(values.email)) {
  } else if (!emailValidator.validate(values.email)) {
    errors.email = "invalid email address";
  }

  return errors;
};

const MyAccountForm = ({ handleSubmit, invalid, pristine, submitting, brandColor }) => {
  return (
    <form onSubmit={ handleSubmit }>
      <div className="userDetails">
        <div className="field">
          <Field name="email" label="Email" type="text" spellCheck={false}  component={BasicNonEditField2}/>
        </div>
        <div className="field">
          <Field name="name" label="Name" type="text" spellCheck={false} autoComplete="name" component={BasicField}/>
        </div>
        <div className="field">
          <Field 
            name="marketingUseAgreement" 
            label="I'd like to to receive occasional updates on Numerable (I can unsubscribe at any time)" 
            brandColor={brandColor}
            component={BasicCheckbox}/>
        </div>
      </div>

      <Button
          type="submit"
          className="fullWidthButton"
          variant="contained"
          color="primary"
          size="large"
          disabled={invalid || pristine || submitting}>
            {submitting ? <CircularProgress size={24} /> : "Save"}
        </Button>
    </form>
  );
};

const ReduxMyAccountForm = reduxForm({
  form: "myAccountForm",
  validate,
  enableReinitialize : true
})(MyAccountForm);

const InitializedMyAccountForm = connect(
  state => ({
    initialValues: state.user
  })
)(ReduxMyAccountForm);

export default InitializedMyAccountForm;